import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Divider, Space } from "antd";

import {
  Header,
  Nav,
  HamburgerMenu,
  BaseTable,
} from "./components";

import {
  loginUserCheck,
  logoutUser,
  spareBrandFetch,
  spareBrandDeleteById,
} from "../redux/actions";

class AdminSpare extends Component {
  constructor() {
    super();
    this.state = {
      isEdit: false,
      toggleMenu: false,
      columns: [
        {
          title: "Image",
          dataIndex: "img",
          key: "img",
          render: (text) => (
            <div>
              <img
                src={text}
                style={{ height: "30px", maxWidth: "100px" }}
                alt="product"
              />
            </div>
          ),
        },
        {
          title: "Brand",
          dataIndex: "title",
          key: "title",
        },
        {
          title: "Created Date",
          dataIndex: "brand_id",
          key: "brand_id",
          render: (text) => {
            const d = new Date(Number(text));
            const date =
              d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
            return date;
          },
        },
        {
          title: "Action",
          key: "action",
          render: (_, record) => (
            <Space size="middle" className="table-action">
              <Button
                type="primary"
                className="btn-edit"
                onClick={() => {
                  window.location = `/admin/sparedetail?id=${record.id}&title=${record.title}`;
                }}
              >
                ดูอะไหล่
              </Button>
              <Divider type="vertical" />
              <Button
                type="primary"
                className="btn-edit"
                onClick={() => {
                  window.location = `/admin/editsparebrand?id=${record.id}`;
                }}
              >
                แก้ไข
              </Button>
              <Divider type="vertical" />
              <Button
                type="primary"
                danger
                onClick={() =>
                  this._onDeleteItem(record.id, record.img)
                }
              >
                ลบ
              </Button>
            </Space>
          ),
        },
      ],
    };
  }

  componentWillMount() {
    this.props.loginUserCheck();
    this.props.spareBrandFetch();
  }

  _handleMenu() {
    this.setState({ toggleMenu: !this.state.toggleMenu });
  }

  _handleLogout() {
    this.props.logoutUser();
  }

  _onDeleteItem(id, img) {
    if (window.confirm("Are you sure you want to delete this item?")) {
      let oldImg = decodeURIComponent(img.substring(70, 101));
      this.props.spareBrandDeleteById(id, oldImg);
    }
  }

  render() {
    if (!this.props.user) return <div></div>;
    return (
      <div>
        <Header name={this.props.user} logout={() => this._handleLogout()} />
        <div className="admin-product">
          <Nav active="spare" />
          <div
            className={this.state.toggleMenu ? "content moveover" : "content"}
          >
            <div className="content-inner">
              <HamburgerMenu onClick={() => this._handleMenu()} />
              <div className="title">
                <h2>อะไหล่ : ยี่ห้อ</h2>
                <div className="btn-addbrand">
                  <Link to="/admin/addsparebrand" className="add-brand">
                    เพิ่มยี่ห้อ
                  </Link>
                </div>
              </div>
              <div className="info">
                <BaseTable
                  columns={this.state.columns}
                  datas={this.props.brands ? this.props.brands : []}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, brand }) => {
  return {
    user: auth.user,
    brands: brand.brands,
  };
};

export default connect(mapStateToProps, {
  loginUserCheck,
  logoutUser,
  spareBrandFetch,
  spareBrandDeleteById,
})(AdminSpare);
